$(function () {
  const histories = {
    init() {
      histories.create();
    },
    create() {
      const swiper = document.getElementById('slider-histories')?.swiper;
      if (swiper) {
        $('.histories-timeline li').on('click', function() {
          const self = $(this);
          swiper.slideTo(self.index());
          const w = $(window).width();

          $('.histories-timeline li').removeClass('active');
          self.addClass('active');

          let spacingPadding = w > 1024 ? 20 : 32;
          if (w < 768) {
            spacingPadding = -12;
          }
          const spacingLeft = $(window).width() - $('.panel.panel-histories [data-row]').width() - spacingPadding;
          const wItem = w > 1024 ? 165 : 80;
          $('.line').stop().animate({
            left: (self.index() * wItem) + spacingLeft
          });
          self.parent().animate({
            scrollLeft: ((self.index() - 1) * wItem) + spacingLeft,
            behavior: 'smooth'
          });
        });
      }
    },
  };

  histories.init();
});
